import _get from 'lodash/get';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { returnSale, toggleSaleAction } from '../../../actions/sales_actions';
import CancelSale from './CancelSale';

function mapStateToProps(state) {
  const saleRevokeCausalsIdForCancel = state.globalSetting.orgData.sale_revoke_causals_id_for_cancel;
  const saleRevokeCauses = state.globalSetting.orgData.sale_revoke_causes;
  const saleRevokeCausalsForCancel = saleRevokeCauses ? saleRevokeCauses.filter(c => saleRevokeCausalsIdForCancel.includes(c.id)) : saleRevokeCauses;
  const generalWarrantyArticles = state.globalSetting.orgData.general_warranty_articles_ids;
  return {
    open: state.sales[`actionCancel-SaleOpen`],
    requestSend: state.requestState[`requestCancel-SaleSend`],
    cardif: _get(
      state,
      'globalSetting.orgData.voluntary_insurance.cardif.article.id'
    ),
    cardifLayerTwoId: _get(
      state,
      'globalSetting.orgData.voluntary_insurance_layer_two_article_id'
    ),
    canRevokeArticlesSales:
    state.authentication.currentUser.canRevokeArticlesSales,
    generalWarrantyArticles,
    canRevokeSales:
    state.authentication.currentUser.canRevokeSales,
    revokeSaleCausals: saleRevokeCausalsForCancel,
    secureSaleArticleId: state.globalSetting.orgData.secure_sale_article_id,
    pledgeArticleId: state.globalSetting.orgData.pledge_article_id,
    b2bSelectedPos: state.globalSetting.orgData.b2b_selected_pos
  };
}

function mapDispatchToProps(dispatch) {
  return {
    returnSale: bindActionCreators(returnSale, dispatch),
    toggleSaleAction: bindActionCreators(toggleSaleAction, dispatch)
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CancelSale);
